import React, { useState } from "react";

type PopupProps = {
  imageUrl: string; // URL of the image to display
  onClose: () => void; // Function to handle closing the popup
  title ?:string
};

const Popup: React.FC<PopupProps> = ({ imageUrl, onClose ,title}) => {
  const [zoomed, setZoomed] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [startDrag, setStartDrag] = useState<{ x: number; y: number } | null>(null);
  const [dragged, setDragged] = useState(false);

  const handleImageClick = (e: React.MouseEvent) => {
    if (dragged) return; // Prevent zoom toggle if dragged
    setZoomed((prev) => {
      if (!prev) {
        setPosition({ x: 0, y: 0 }); // Reset position when zooming in
      }
      return !prev;
    });
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    if (!zoomed) return;
    setIsDragging(true);
    setStartDrag({ x: e.clientX - position.x, y: e.clientY - position.y });
    setDragged(false);
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !zoomed || !startDrag) return;
    const newX = e.clientX - startDrag.x;
    const newY = e.clientY - startDrag.y;
    // If moved more than a few pixels, consider it a drag
    if (Math.abs(newX - position.x) > 3 || Math.abs(newY - position.y) > 3) {
      setDragged(true);
    }
    setPosition({
      x: newX,
      y: newY,
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setStartDrag(null);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div className="relative bg-white max-h-[750px] rounded-lg shadow-lg max-w-[400px] w-full p-2 ">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-black p-4 "
          onClick={onClose}
        >
          ✕
        </button>
        <div className="p-2 pt-12">
          <div className=" py-2">{title}</div>
          {" "}
          <img
            src={imageUrl}
            alt="Popup"
            className={`rounded-t-lg object-contain w-full transition-transform duration-300 ${
              zoomed ? 'cursor-zoom-out-magnifier' : 'cursor-zoom-in-magnifier'
            }`}
            style={{
              transform: `scale(${zoomed ? 2 : 1}) translate(${zoomed ? position.x : 0}px, ${zoomed ? position.y : 0}px)`,
              zIndex: zoomed ? 60 : 1,
              cursor: zoomed ? (isDragging ? 'grabbing' : 'grab') : undefined,
            }}
            onClick={handleImageClick}
            onMouseDown={handleMouseDown}
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
};

export default Popup;
